<template>
<a-select
    show-search
    :filter-option="filterOption"
    :show-arrow='false'
    label-in-value
    :value="selected"
    :placeholder="placeholder"
    :not-found-content="loading ? undefined : '请输入站点名称进行搜索'"
    @search="getStationList"
    @change="handleChange"
    :disabled="disabled"
    :allow-clear='allowClear'
>
    <a-spin v-if="loading" slot="notFoundContent" size="small" />
    <a-select-option v-for="item of stationList" :key="item.id">{{item.name}}</a-select-option>
</a-select>
</template>

<script>
import Core from '../../core';

let lastTime = Date.now()
export default {
    name: 'SelectStationByName',
    model: {
        prop: 'value',
        event: 'update'
    },
    props: {
        value: {},
        disabled: {},

        operatorId: { type: [Number, String] },
        orgId: { type: [Number, String] },

        allowClear: { type: Boolean, default: true, },
        placeholder: { type: String, default: '请选择站点', },
    },
    data() {
        return {
            loading: false,
            stationList: [],

            selected: undefined,
        };
    },
    watch: {
        value: {
            immediate: true,
            handler(n) {
                console.log('SelectStationByName watch value:', n)
                if (!n) {
                    this.selected = undefined
                }
            }
        },
        'operatorId': {
            immediate: true,
            handler(n) {
                console.log('SelectStationByName watch operatorId:', n)
                if (!n) {
                    this.selected = undefined
				    this.stationList = [];
                }
            }
        },
        'orgId': {
            immediate: true,
            handler(n) {
                console.log('SelectStationByName watch orgId:', n)
                if (!n) {
                    this.selected = undefined
				    this.stationList = [];
                }
            }
        },
        // 'orgId': function(newVal) {
        //     console.log('orgId newVal:', newVal);
        //     if (newVal) {
        //         this.getStationListByOrg(newVal);
        //     } else {
		// 		this.stationList = [];
        //     }
        // },
    },
    computed: {
    },
    methods: {
        getStationList(name, flag_search = false) {
            // 节流
            if (this.stationList.length) {
                let nowTime = Date.now()
                if (nowTime - lastTime < 500) {return}
                lastTime = nowTime
            }

            if (!name && !flag_search) { return }

            if (this.loading) { return }
            this.loading = true

            if (this.orgId) {
                return this.getStationListByOrg(this.orgId)
            }

            let params = {
                page_size: 100,
                name: name,
                operator_id: this.operatorId || undefined,
            }
            Core.Api.Station.listByName(params).then(res => {
                this.stationList = res.station_list
            }).finally(() => {
                this.loading = false
            })
        },
        async getStationListByOrg(org_id) { // 获取选择用 充电站 列表
            if (!org_id) {
                return this.stationList = [];
            }
            let page = 0, total = 0, list = []
            while(true) {
                page++
                let res = await Core.Api.Station.listByOrgId(page, org_id)
                total = res.count
                if (!res.station_list || !res.station_list.length) { break; }
                list.push(...res.station_list)
                if (list.length === total) { break; }
            }
            this.loading = false
            this.stationList = list
            console.log("getStationList res", this.stationList)
        },

        filterOption(inputValue, option) {
            let name = option.componentOptions.children[0].text || ''
            return name.includes(inputValue)
        },
        // 选择
        handleChange(value = {}) {
            console.log('SelectStationByName handleChange value:', value)
            this.selected = value
            this.loading = false
            this.stationList = []

            this.$emit('update', value.key)
            this.$emit('change', value.key)
        },
    },
};
</script>
